// @deprecated — Use domain-specific APIs (dataflowCoreApi, dataflowSCCApi, etc.) for new code.
// This file is retained for backward compatibility with existing hooks (useDataFlow.js).
// Will be removed when hooks are refactored in Phase 3.
import { httpClient } from '../httpClient';

const ROUTE_MAP = {
  source:      { path: '/dataflow/source',       entity: 'Source' },
  inKingdom:   { path: '/dataflow/inKingdom',    entity: 'InKingdom' },
  crossBorder: { path: '/dataflow/crossBorder',  entity: 'CrossBorder' },
};

export const dataflowApi = {
  getAll: () =>
    httpClient.get('/dataflow/all'),

  createSource: (data) =>
    httpClient.post('/dataflow/source', data),

  updateSource: (id, data) =>
    httpClient.put(`/dataflow/source/${id}`, data),

  deleteSource: (id) =>
    httpClient.delete(`/dataflow/source/${id}`),

  createInKingdom: (data) =>
    httpClient.post('/dataflow/inKingdom', data),

  updateInKingdom: (id, data) =>
    httpClient.put(`/dataflow/inKingdom/${id}`, data),

  deleteInKingdom: (id) =>
    httpClient.delete(`/dataflow/inKingdom/${id}`),

  createCrossBorder: (data) =>
    httpClient.post('/dataflow/crossBorder', data),

  updateCrossBorder: (id, data) =>
    httpClient.put(`/dataflow/crossBorder/${id}`, data),

  deleteCrossBorder: (id) =>
    httpClient.delete(`/dataflow/crossBorder/${id}`),

  createFlow: (data) =>
    httpClient.post('/dataflow/flows', data),

  updateFlow: (id, data) =>
    httpClient.put(`/dataflow/flows/${id}`, data),

  deleteFlow: (id) =>
    httpClient.delete(`/dataflow/flows/${id}`),

  getStats: () =>
    httpClient.get('/dataflow/stats'),

  exportReport: (language) =>
    httpClient.post('/dataflow/export-report', { language }, { responseType: 'blob' }),

  // Composite methods used by useDataFlow.js hooks
  saveSystem: (type, id, data) => {
    const route = ROUTE_MAP[type];
    if (!route) throw new Error(`Unknown system type: ${type}`);
    return id
      ? httpClient.put(`${route.path}/${id}`, data)
      : httpClient.post(route.path, data);
  },

  deleteSystem: (type, id) => {
    const route = ROUTE_MAP[type];
    if (!route) throw new Error(`Unknown system type: ${type}`);
    return httpClient.delete(`${route.path}/${id}`);
  },

  saveFlow: (id, data) =>
    id
      ? httpClient.put(`/dataflow/flows/${id}`, data)
      : httpClient.post('/dataflow/flows', data),

  // ── P3: Canvas & Gap Detection ──────────────────────────────────────────────
  getCanvasData: (organizationId) =>
    httpClient.get('/dataflow/canvas-data', {
      params: organizationId ? { organizationId } : undefined,
    }),

  saveCanvasPositions: (positions) =>
    httpClient.post('/dataflow/canvas-positions', { positions }),

  getSuggestions: (organizationId) =>
    httpClient.get('/dataflow/suggestions', {
      params: organizationId ? { organizationId } : undefined,
    }),

  confirmSuggestion: (suggestionId, flowData) =>
    httpClient.post(`/dataflow/suggestions/${suggestionId}/confirm`, flowData),

  dismissSuggestion: (suggestionId) =>
    httpClient.post(`/dataflow/suggestions/${suggestionId}/dismiss`),

  discoveryWebhook: (payload) =>
    httpClient.post('/dataflow/discovery-webhook', payload),

  // ── P3: Penalty Exposure ────────────────────────────────────────────────────
  getPenaltyExposure: (organizationId) =>
    httpClient.get('/dataflow/penalty-exposure', {
      params: organizationId ? { organizationId } : undefined,
    }),

  // ── P3: NDGP Export ─────────────────────────────────────────────────────────
  exportNDGP: (data) =>
    httpClient.post('/dataflow/export-ndgp', data),

  // ── P3: Residency Monitoring ────────────────────────────────────────────────
  runResidencyMonitoring: () =>
    httpClient.get('/dataflow/residency/monitoring-run'),

  // ── P3: Lineage ─────────────────────────────────────────────────────────────
  getLineageGraph: (flowId) =>
    httpClient.get(`/dataflow/lineage/graph/${flowId}`),

  traceFieldLineage: (field) =>
    httpClient.get('/dataflow/lineage/trace', { params: { field } }),

  createLineageNode: (data) =>
    httpClient.post('/dataflow/lineage/nodes', data),

  createLineagePath: (data) =>
    httpClient.post('/dataflow/lineage/paths', data),
};
